import * as React from 'react';
import { Modal } from './Modal';
import { FlexBetween } from '../Flexbox/Flexbox';
import ButtonPrimary from '../Button/ButtonPrimary';
import { __ } from 'react-i18n';
import ButtonSecondary from '../Button/ButtonSecondary';
import { Spacer } from '../Defaults';

export interface ConfirmDialogType {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  display?: boolean;
}

export class ConfirmDialog extends React.PureComponent<ConfirmDialogType> {
  static defaultProps = {
    display: true,
  };

  render() {
    return (
      <Modal
        closeModal={this.props.onCancel}
        size="medium"
        style={{ height: 'auto', padding: '25px', maxWidth: '500px' }}
        display={this.props.display}
      >
        <p>{this.props.message}</p>
        <FlexBetween>
          <ButtonPrimary click={this.props.onConfirm}>
            {__('Potvrdiť')}
          </ButtonPrimary>
          <Spacer spaceWidth={10} />
          <ButtonSecondary click={this.props.onCancel}>
            {__('Zrušiť')}
          </ButtonSecondary>
        </FlexBetween>
      </Modal>
    );
  }
}
